import { Component, OnInit } from '@angular/core';
import { Dokument } from './dokument';
import { BaseUpdateComponent, BaseDataService, QueryParameter, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { NgbDatepickerDayView } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker.module';
import { List } from 'immutable';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-dokument-update',
  templateUrl: './dokument-update.component.html'
})
export class DokumentUpdateComponent 
extends BaseUpdateComponent<Dokument>
implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
   }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('Datum', Validators.required, 'required', 'DOKUMENT.DATUM.VALIDATION.REQUIRED');
    let date = new Date();
    this.fc.Datum.setValue({day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear()});
    let parameterList: List<QueryParameter> = List(this.modelData.MainList.GetParameters);
    this.TransferParameters = this.TransferParameters.set(0, parameterList);
  }


  onDatumChange(value) {
    if (value != null) {
        let parameterList: List<QueryParameter> = List([new QueryParameter('Datum', value)]);
        this.TransferParameters = this.TransferParameters.set(1, parameterList);
    }
  }

  //SaveItem(){
    //if (this.modelData.MainTitle == "Otkup efektive"){
      //this.baseFormGroup.get("Vrsta").setValue("U");
      // this.Item.Vrsta='U';
    //}
    //else {
      //this.baseFormGroup.get("Vrsta").setValue("I");
//      this.Item.Vrsta='I';
    //}

    //super.SaveItem();
  //}
}
